import type { Conversation, DocumentKind, MemberRole } from '@jabberr/core';
import type { TopBarAction } from '../state/drawer.js';
import { PARK_DESCRIPTION, WRITE_KINDS } from '../components/WriteMenu.js';

/** The phone "More" menu for a conversation. Under 800px the conversation header (Write..., Talk instead, the
 *  details toggle) is hidden and the top bar carries these instead. Write... is offered in any active conversation,
 *  chat, transcript review or meeting alike, and is off while a reply is streaming or before there is anything to
 *  draw on; Talk instead only where a talk can happen (not for guests, not in a personal space). */
export function conversationActions(args: {
  conversation: Pick<Conversation, 'status' | 'lastTurnSeq' | 'kind'>;
  streaming: boolean;
  memberRole: MemberRole | undefined;
  projectKind: string | null;
  onWrite: (kind: DocumentKind) => void;
  /** Add to parking lot; absent: not offered. */
  onPark?: () => void;
  onTalk: () => void;
  onDetails: () => void;
}): TopBarAction[] {
  const { conversation: c, memberRole, projectKind } = args;
  const actions: TopBarAction[] = [];
  if (c.status === 'active') {
    actions.push({
      label: 'Write...',
      disabled: args.streaming || c.lastTurnSeq === 0,
      submenu: [
        ...(args.onPark ? [{ label: 'Add to parking lot', description: PARK_DESCRIPTION, onSelect: args.onPark }] : []),
        ...WRITE_KINDS.map((k) => ({ label: k.label, description: k.description, onSelect: () => args.onWrite(k.kind) })),
      ],
    });
  }
  if (memberRole && memberRole !== 'guest' && projectKind && projectKind !== 'personal') actions.push({ label: 'Talk instead', onSelect: args.onTalk });
  actions.push({ label: 'Details', onSelect: args.onDetails });
  return actions;
}
